<template>
<div class="chapter">
<div class="inner_page">
<div class="dedication1" id="ded">
<p class="ded"><a id="pageiv"></a>IN FOND MEMORY OF IAN AND SAM,</p>
<p class="ded">TO CHRIS AS ALWAYS,</p>
<p class="ded">AND TO BARBARA, ANITA, JOAN AND REYN,</p>
<p class="ded">MANY THANKS.</p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 9781446359211_epub_ded_r1.vue?2763dd57